module.exports = __webpack_public_path__ + "img/dfy.4c830633.png";